// removed by extract-text-webpack-plugin
module.exports = {"slideIn":"Drawer-style__slideIn__50c97140","slideOut":"Drawer-style__slideOut__50c97140","drawer":"Drawer-style__drawer__50c97140"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Drawer/Drawer-style.scss
// module id = ./src/components/Drawer/Drawer-style.scss
// module chunks = 4